import * as React from 'react';

// COMPONENTS
import RoleListItem from './RoleListItem';
import Button from '../../components/Button';

// ICONS
import { ReactComponent as PlusIcon } from '../../assets/svg/plus.svg';

// TYPES
import { StaffDashboardStaffMember } from '../../api/models';

interface RoleListTypes {
	role: string;
	peopleList: StaffDashboardStaffMember[];
	isPastProfile?: boolean;
	setReinstateStaffId?: React.Dispatch<React.SetStateAction<string>>;
	setShowReinstateStaffModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

const RoleList: React.FC<RoleListTypes> = ({
	role,
	peopleList,
	isPastProfile,
	setReinstateStaffId,
	setShowReinstateStaffModal
}) => {
	const [maxItem, setMaxItem] = React.useState<number>(5);

	return (
		<section className="info-section complaints-page">
			{peopleList.length > 0 && (
				<>
					<div className="section-header bold">
						{role}
						<span className="quantity">{peopleList.length}</span>
					</div>

					{peopleList.slice(0, maxItem).map((people: StaffDashboardStaffMember) => {
						return (
							<RoleListItem
								key={people.id}
								people={people}
								isPastProfile={isPastProfile}
								setReinstateStaffId={setReinstateStaffId}
								setShowReinstateStaffModal={setShowReinstateStaffModal}
							/>
						);
					})}
					{maxItem < peopleList.length && (
						<Button
							buttonIcon={<PlusIcon className="link-icon" />}
							className="btn-secondary btn-show-more"
							type="button"
							onClick={() => setMaxItem(peopleList.length)}
						>
							Show {peopleList.length - maxItem} more
						</Button>
					)}
				</>
			)}
		</section>
	);
};

export default RoleList;
